import { Injectable } from '@angular/core';
import { PDFDocument, rgb, Rotation, degrees } from 'pdf-lib';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class PdfWatermarkService {

  constructor(private http: HttpClient) {}

  async addWatermarkToPdf(pdfBytes: Uint8Array, watermarkText: string): Promise<Uint8Array> {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pageCount = pdfDoc.getPages().length;

    for (let i = 0; i < pageCount; i++) {
      const page = pdfDoc.getPages()[i];

      page.drawText(watermarkText, {
        x: 75,
        y: 400,
        size: 50,
        color: rgb(0.5, 0.5, 0.5),
        rotate: degrees(45), // Corrección aquí
      });
    }

    const modifiedPdfBytes = await pdfDoc.save();
    return modifiedPdfBytes;
  }

  async addWatermarkToPdfFromPath(pdfPath: string, watermarkText: string): Promise<string | Uint8Array> {
    try {
      // Carga el PDF desde la ruta y conviértelo en ArrayBuffer
    const pdfArrayBuffer = await this.http.get(pdfPath, { responseType: 'arraybuffer' }).toPromise();

    if (!pdfArrayBuffer) {
      throw new Error('No se pudo cargar el PDF.');
    }
      
      // Convierte el ArrayBuffer en Uint8Array
    const pdfBytes = new Uint8Array(pdfArrayBuffer);

      // Agrega la marca de agua al PDF
      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pageCount = pdfDoc.getPages().length;

      for (let i = 0; i < pageCount; i++) {
        const page = pdfDoc.getPages()[i];

        page.drawText(watermarkText, {
          x: 150,
          y: 300,
          size: 50,
          color: rgb(0, 0, 0),
          rotate: degrees(45), // Corrección aquí
        });
      }

      // Devuelve el PDF con marca de agua como una cadena base64
      const modifiedPdfBytes = await pdfDoc.save();
      const modifiedPdfArrayBuffer = modifiedPdfBytes.buffer; // Convierte a ArrayBuffer
      return new Uint8Array(modifiedPdfArrayBuffer);
    } catch (error) {
      console.error('Error al cargar o procesar el PDF:', error);
      throw error;
    }
  }
}
